 
/* eslint-disable react/prop-types */
import React from 'react';
import { MegaMenuMobileLink } from './MegaMenuMobileLink.tsx';

const MegaMenuMobileLinkBlockContent = ({ linkBlock }) => {
  const isLink = !!linkBlock?.url?.value;
  const title = linkBlock.title?.value || linkBlock.name;

  return (
    <div>
      {isLink ? (
        <a
          className="mega-menu-mobile__link-block-header"
          href={linkBlock.url.value}
          target={linkBlock.target?.value || "_self"}
        >
          {title}
        </a>
      ) : (
        <span className="mega-menu-mobile__link-block-header">{title}</span>
      )}
      <ul>
        {linkBlock.linkList?.expandedValue?.map((link, index) => (
          <li key={`${link.text}-${index}`}>
            <MegaMenuMobileLink 
              key={`${link.text}-${index}`}
              href={link.link?.value}
              description={link.description?.value}
              iconSrc={link.icon?.value?.url}
              target={link.target?.value}
              title={link.title?.value || link.name}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MegaMenuMobileLinkBlockContent;
